import { Search } from '@mui/icons-material'
import { Box, styled, TextField, Button } from '@mui/material'
import theme from 'lib/theme'

export const SearchField = styled(TextField, {
  shouldForwardProp: (props) => props !== 'hover' && props !== 'paddingLeft',
})<{ hover: boolean; paddingLeft?: string }>(({ hover, paddingLeft }) => ({
  width: '100%',
  transition: '0.5s',
  '& .MuiOutlinedInput-root': {
    paddingRight: 0,
    paddingLeft,
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    borderColor: 'transparent',
    backgroundColor: hover
      ? theme.palette.commonColors.white
      : theme.palette.action.hover,
    fontWeight: 'bold',
    '&.Mui-focused fieldset': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: 0,
  },
  '& .MuiOutlinedInput-input': {
    '&:hover': { color: theme.palette.text.primary },
  },
  '& .MuiFormHelperText-root': {
    color: theme.palette.primary.main,
  },
  [theme.breakpoints.between('xs', 'sm')]: {
    marginTop: theme.spacing(1),
  },
  input: {
    color: theme.palette.text.primary,
    '&::placeholder': {
      color: theme.palette.text.secondary,
      fontWeight: 'bold',
      opacity: 1,
      transition: '0.5s',
    },
  },
}))

export const BlueSearchIcon = styled(Search, {
  shouldForwardProp: (props) => props !== 'query',
})<{ query: string }>(({ query }) => ({
  backgroundColor:
    query.length < 3
      ? theme.palette.action.disabled
      : theme.palette.primary.main,
  fill: theme.palette.commonColors.white,
  width: '52px',
  borderRadius: '0 4px 4px 0',
  padding: '6px',
  '&:hover': {
    cursor: query.length < 3 ? 'auto' : 'pointer',
    background: 'transparent',
    backgroundColor:
      query.length < 3
        ? theme.palette.action.disabled
        : theme.palette.primary.main,
    fill: theme.palette.commonColors.white,
  },
}))

export const ResponsiveBoxWrapper = styled(Box, {
  shouldForwardProp: (props) => props !== 'showOverlay',
})<{ showOverlay: boolean }>(({ showOverlay }) => ({
  [theme.breakpoints.between('xs', 'sm')]: {
    width: '100vw',
    height: '100vh',
    overflowX: 'hidden',
    position: 'fixed',
    zIndex: 1000,
    left: 0,
    top: 0,
    backgroundColor: theme.palette.commonColors.white,
    visibility: showOverlay ? 'visible' : 'hidden',
    borderLeft: 0,
  },
}))

export const ForwardButtonWrapper = styled(Button)(() => ({
  background: 'transparent',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.text.secondary,
  '&:hover': {
    color: theme.palette.text.primary,
    backgroundColor: 'transparent',
    svg: { fill: theme.palette.icon.hover },
  },
}))
